import type {
	ConditionalLogicType,
	OperatorConditions,
	RulesCondition,
} from '@/src/Types/Blocks/Form';
import type { AllFieldType } from '@/src/Types/GF/Fields';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const evaluateConditionnalLogic = (
	conditionalLogic: ConditionalLogicType,
	values: any,
	fields: AllFieldType[]
) => {
	const { rules, actionType, logicType, enabled } = conditionalLogic;

	if (!enabled) return true;

	const defaultShow = actionType === 'show' ? false : true;
	const returnValues: any = {};
	const inputs = [values.values];

	if (!rules) {
		return true;
	} else {
		rules.map((rule: RulesCondition) => {
			const { fieldId, value: valueForComparison, operator } = rule;
			returnValues['input_' + fieldId.replaceAll('.', '_')] = defaultShow;

			inputs.forEach((input: any) => {
				for (const [inputKey, inputValue] of Object.entries(input)) {
					const field = checkFieldType(fieldId, fields);
					const _fieldId = fieldId.replaceAll('.', '_');

					let comparaison = inputKey.includes(_fieldId);

					if (field?.type === 'checkbox') {
						const { choices } = field;
						const index = choices
							.map(function (e) {
								return e.value;
							})
							.indexOf(valueForComparison);
						comparaison = inputKey.includes(fieldId + '_' + (index + 1));
					}

					if (comparaison) {
						const childrenInput = Object.keys(returnValues).filter((key) => key);
						let parent = '';
						childrenInput.map((child) => {
							if (!child.startsWith(`input_${fieldId}_`)) {
								parent = child;
							}
						});

						delete returnValues[parent];

						const isRuleMet = compareValues(inputValue, operator, valueForComparison);

						if (isRuleMet) {
							returnValues[inputKey] = !defaultShow;
						} else {
							returnValues[inputKey] = defaultShow;
						}
					}
				}
			});
		});

		if (logicType === 'any') {
			//if at least one returnValue is true
			if (Object.values(returnValues).some((v) => v === !defaultShow)) {
				return !defaultShow;
			} else {
				return defaultShow; //false;
			}
		} else {
			//if all returnValues are true
			if (Object.values(returnValues).every((v) => v === !defaultShow)) {
				return !defaultShow;
			} else {
				return defaultShow; //false;
			}
		}
	}

	return defaultShow;
};

function checkFieldType(fieldId: string, fields: AllFieldType[]) {
	const found = fields.find((field: AllFieldType) => String(field.id) === fieldId);
	return found;
}

function compareValues(enteredValue: any, operator: OperatorConditions, valueForComparison: any) {
	let isRuleMet = false;
	switch (operator) {
		case 'is':
			{
				isRuleMet = enteredValue === valueForComparison;
			}
			break;
		case 'isnot':
			{
				isRuleMet = enteredValue != valueForComparison;
			}
			break;
		case 'contains':
			{
				if (enteredValue) {
					isRuleMet = enteredValue.toLowerCase().includes(valueForComparison.toLowerCase());
				}
			}
			break;
		case '<':
			{
				//check if is not "alphabetical"
				if (!isNaN(enteredValue) && !isNaN(valueForComparison)) {
					//check if not empty and if not clear (otherwise = 0)
					if (enteredValue) {
						isRuleMet = Number(enteredValue) < Number(valueForComparison);
					}
				}
			}
			break;
		case '>':
			{
				//check if is not "alphabetical"
				if (!isNaN(enteredValue) && !isNaN(valueForComparison)) {
					//check if not empty and if not cleared (otherwise = 0)
					if (enteredValue) {
						isRuleMet = Number(enteredValue) > Number(valueForComparison);
					}
				}
			}
			break;
		case 'starts_with':
			{
				if (typeof enteredValue === 'string' && typeof valueForComparison === 'string') {
					isRuleMet = enteredValue.startsWith(valueForComparison);
				}
			}
			break;
		case 'ends_with':
			{
				if (typeof enteredValue === 'string' && typeof valueForComparison === 'string') {
					isRuleMet = enteredValue.endsWith(valueForComparison);
				}
			}
			break;
	}

	return isRuleMet;
}
